/**
 * List of settings keys for the system scope.
 */
export type MobizSettingsKeySystem =
  'GlobalSettings';

/**
 * List of settings keys for the organization scope.
 */
export type MobizSettingsKeyOrganization =
  'ReportModuleSettings' |
  'SalesModuleSettings' |
  'SalesOrganizationSettings' |
  'SynchronizationSettings' |
  'WorkModuleSettings';

/**
 * List of "recent objects" settings keys for the user scope.
 */
export type MobizSettingsKeyRecentObject =
  'RecentNotifications' |
  'RecentCountries' |
  'RecentCurrencies' |
  'RecentCustomers' |
  'RecentInvoices' |
  'RecentItems' |
  'RecentJobs' |
  'RecentOrders' |
  'RecentQuotes';

/**
 * List of settings keys for the user scope.
 */
export type MobizSettingsKeyUser =
  MobizSettingsKeyRecentObject |
  'NotificationSettings' |
  'ReportUserSettings';

/**
 * List of available settings keys.
 */
export type MobizSettingsKey = MobizSettingsKeySystem | MobizSettingsKeyOrganization | MobizSettingsKeyUser;
